import React, { useEffect, useState } from 'react';
import Navbar from '../../components/layout/Navbar';
import Footer from '../../components/layout/Footer';
import ScienceBackground from '../../components/layout/ScienceBackground';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../../config/api';


const CourseCard = ({ course, onSelect }) => (
  <div className="bg-white rounded-xl shadow-[0_2px_10px_rgb(0,0,0,0.06)] hover:shadow-[0_8px_30px_rgb(0,0,0,0.12)] border border-slate-100 flex flex-col overflow-hidden transition-shadow duration-300 cursor-pointer group">
    <div className={`w-full h-56 ${course.bg_pattern || 'bg-gradient-to-br from-blue-600 to-indigo-800'} relative flex flex-col items-center justify-center text-center p-4 overflow-hidden`}>
      <div className="absolute inset-0 bg-yellow-500/10 rotate-12 scale-150 transform transition-transform duration-700 group-hover:rotate-45"></div>
      <div className="z-10 space-y-2">
        <span className="px-3 py-1 bg-white/20 backdrop-blur-md rounded-full text-[10px] font-black text-white uppercase tracking-widest border border-white/10">
          {course.subject || 'Science'}
        </span>
        <h3 className="text-white font-sinhala font-black text-2xl drop-shadow-md leading-tight">
          {course.title}
        </h3>
      </div>
    </div>
    
    <div className="p-6 flex-grow flex flex-col font-sinhala">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 bg-slate-50 rounded-full flex items-center justify-center text-slate-400 font-bold border border-slate-100">
          {course.teacher_name?.charAt(0) || 'T'}
        </div>
        <div>
          <p className="text-[10px] text-slate-400 font-bold uppercase tracking-widest leading-none mb-1">Assigned Teacher</p>
          <p className="font-black text-slate-700 text-sm uppercase">{course.teacher_name || 'Kasun Walakumbura'}</p>
        </div>
      </div>
      
      <div className="flex justify-between items-center mb-6">
        <span className="inline-block px-3 py-1 bg-teal-50 text-teal-600 text-[10px] font-black rounded uppercase tracking-widest">
          {course.tag}
        </span>
        <div className="font-sans font-black text-slate-800 text-lg">
          LKR {course.price}
        </div>
      </div>
      
      <div className="mt-auto">
        <button 
          onClick={() => onSelect(course)}
          className="w-full py-3.5 bg-gradient-to-r from-orange-400 to-orange-600 text-white font-black rounded-2xl shadow-lg shadow-orange-100 hover:scale-[1.02] active:scale-95 transition-all text-sm uppercase tracking-widest"
        >
          View Months & Enroll
        </button>
      </div>
    </div>
  </div>
);

const Courses = () => {
  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchCourses = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/get_courses.php`);
        const result = await response.json();
        if (result.status === 'success') {
          setCourses(result.data);
        }
      } catch (error) {
        console.error("Error fetching courses:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCourses();
  }, []);

  return (
    <div className="font-sans bg-slate-50 min-h-screen text-slate-800 overflow-x-hidden selection:bg-orange-500 selection:text-white relative flex flex-col pt-24">
      <ScienceBackground />
      <Navbar />

      <div className="relative z-10 pt-12 pb-10 px-6 text-center w-full max-w-4xl mx-auto">
        <div className="inline-block px-4 py-1.5 rounded-full bg-blue-100 text-blue-600 font-bold text-sm tracking-wide mb-4 border border-blue-200 shadow-sm">
          Explore Our Classes 🚀
        </div>
        <h1 className="text-4xl md:text-5xl font-black uppercase tracking-tight text-slate-800 mb-4 drop-shadow-sm font-sans">
          ALL <span className="text-blue-600">COURSES</span>
        </h1>
        <p className="text-lg text-slate-500 font-medium max-w-2xl mx-auto font-sinhala leading-relaxed">
          පහත දැක්වෙන ඕනෑම පන්තියක් සඳහා ඔබට මාසිකව ලියාපදිංචි වී ඉගෙනීම් කටයුතු සිදු කළ හැකිය.
        </p>
      </div>

      <div className="relative z-10 flex-grow px-6 md:px-12 pb-24 max-w-[1400px] mx-auto w-full flex flex-col gap-8">
        
        {/* Main Content Area */}
        <div className="w-full flex flex-col gap-6">
          
          {loading ? (
            <div className="flex justify-center py-24">
              <div className="w-12 h-12 border-4 border-orange-500 border-t-transparent rounded-full animate-spin"></div>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 pt-2">
              {courses.map((course) => (
                <CourseCard 
                  key={course.id} 
                  course={course} 
                  onSelect={(c) => navigate(`/course-details/${c.id}`)}
                />
              ))}
            </div>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Courses;
